import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function SuperadminGuard({ children }) {
  const { userInfo } = useSelector((s) => s.auth);
  if (!userInfo?.is_superadmin) {
    return <Navigate to="/" replace />;
  }
  return children;
}
